import { md } from "config/variable";
import styled, { css } from "styled-components";

const Sibarstyle = styled.div`
  display: flex;
  flex-direction: row;
  .sidebar {
    width: 84px;
    height: calc(100vh - 64px);
    overflow: auto;
    background: ${(props) => props.theme.bgcolorskyblue};
    color: ${(props) => props.theme.textcolordwhite3};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    border-right: 1px solid ${(props) => props.theme.colorbluegreylight};
    .linkstyle {
      color: ${(props) => props.theme.textcolordwhite3};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 14px 0;
      height: auto;
      position: relative;
      margin: 0;
      font-size: 12px;
      &:hover,
      &.active {
        text-decoration: none;
        background: rgb(100, 196, 245);
      }
      &:after {
        content: "";
        position: absolute;
        width: 3px;
        background-color: ${(props) => props.theme.textcolordarkblue};
        height: 0;
        right: 0;
        top: 0;
        transition: 0.2s ease all;
      }
      span {
        margin: 0;
        font-size: 12px;
        &.anticon {
          font-size: 20px;
          margin-bottom: 8px;
        }
      }
    }
  }
  .sider-subsidebar {
    width: 211px;
    background: ${(props) => props.theme.colordwhitedark};
    border-right: 1px solid ${(props) => props.theme.colorbluegreylight};
    color: ${(props) => props.theme.textcolordwhite3};
    padding: 20px;
    position: absolute;
    top: 0;
    bottom: 0;
    transform: translateX(-100%);
    transition: 0.2s ease all;
    height: calc(100vh - 64px);
    overflow: auto;
    &.fax-sidebar {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @media (min-width: 0px) and (max-width: 820px) {
        &.active {
          display: none;
        }
      }
      ul {
        border-bottom: none;
      }
      .bottom-section {
        label {
          font-weight: 400;
          font-size: 14px;
          margin-right: 15px;
          color: ${(props) => props.theme.textcolordblack};
          margin-bottom: 4px;
          display: block;
        }
        .usage {
          border: 1px solid ${(props) => props.theme.colorbluegreylight};
          border-radius: 8px;
          margin-top: 10px;
          padding: 10px;
          font-size: 14px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          color: ${(props) => props.theme.textcolordblack};
          span {
            display: block;
          }
        }
      }
    }
    .fax-title-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .ant-btn{
        width: auto;
      }
      .ant-typography {
        margin-bottom: 0;
      }
      .anticon {
        color: ${(props) => props.theme.primary};
      }
    }
    ul {
      li {
        .ant-badge {
          .ant-scroll-number {
            top: 6px;
          }
        }
      }
    }
    &.active {
      transform: translateX(0);
      visibility: visible;
      opacity: 1;
      position: relative;
      ${md(css`
        position: absolute;
        transform: translateX(70px);
        z-index: 2;
        &.is-closed {
          transform: translateX(-100%);
        }
      `)}
    }
    ul {
      list-style: none;
      border-bottom: 1px solid ${(props) => props.theme.colorbluegreylight};
      margin-bottom: 25px;
      padding-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
        border-bottom: 0;
      }
      .ant-typography {
        font-size: 14px;
        margin-bottom: 25px;
        padding: 0 20px;
        position: relative;
        .end {
          .anticon {
            left: auto;
            right: 0;
            cursor: pointer;
          }
        }
        .anticon {
          font-size: 20px;
          position: absolute;
          left: -10px;
          color: ${(props) => props.theme.textcolordarkgrey};
        }
      }
      .actions {
        right: 0;
        opacity: 0;
        visibility: hidden;
        span {
          &.anticon {
            display: inline-block;
          }
        }
      }
      .linkstyle {
        font-size: 12px;
        color: ${(props) => props.theme.textcolordblack};
        margin-bottom: 15px;
        padding: 0 20px;
        white-space: nowrap;
        position: relative;
        &.chat-bot {
          padding: 0 10px 0 0;
          justify-content: flex-start;
          position: relative;
          max-width: calc(100% - 16px);
          width: 100%;
          .chat-pic {
            display: block;
            background-color: transparent;
            height: auto;
            width: auto;
            min-width: 23px;
            .anticon {
              display: block;
              font-size: 22px;
            }
          }
        }
        .badge {
          background-color: ${(props) => props.theme.colordanger};
          color: ${(props) => props.theme.textcolordwhite3};
          font-size: 8px;
          border-radius: 2px;
          padding: 2px 3px;
          line-height: 1;
          font-weight: 600;
          position: absolute;
          top: -7px;
          right: 71px;
        }
        &:hover,
        &.active {
          text-decoration: none;
          color: ${(props) => props.theme.primary};
        }
        span {
          display: none;
        }
      }
    }
  }
`;
export default Sibarstyle;
